import { render, staticRenderFns } from "./TrainingDetail.vue?vue&type=template&id=b3d24c4e&"
import script from "./TrainingDetail.vue?vue&type=script&lang=js&"
export * from "./TrainingDetail.vue?vue&type=script&lang=js&"
import style0 from "./TrainingDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports